import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";

// サンクスポイント表示名称を取得
export function getThanksPointName(defaultName: string) {
  let thanksPointName = commons?.userInfo?.thanksPointName;
  // サンクスポイント表示名称がnull、またはundefined、または空、またはデフォルト値の場合
  if (thanksPointName == null || thanksPointName == "" || thanksPointName == CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1) {
    thanksPointName = defaultName;
  }
  return thanksPointName;
}

// サンクス専用ポイント表示名称を取得
export function getThanksOnlyPointName(defaultName: string) {
  let thanksOnlyPointName = commons?.userInfo?.thanksOnlyPointName;
  // サンクス専用ポイント表示名称がnull、またはundefined、または空、またはデフォルト値の場合
  if (thanksOnlyPointName == null || thanksOnlyPointName == "" || thanksOnlyPointName == CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME1) {
    thanksOnlyPointName = defaultName;
  }
  return thanksOnlyPointName;
}
